import { MillwrightsSortOption } from '@/types';
import { useState } from 'react';

export const useMillwrightsSort = (
  initialSortOption: MillwrightsSortOption,
) => {
  const [sortOption, setSortOption] =
    useState<MillwrightsSortOption>(initialSortOption);

  const updateSortOption = (option: MillwrightsSortOption) => {
    setSortOption(option);
  };

  return {
    sortOption,
    updateSortOption,
  };
};
